export const generateNameHandler = (type = '') => type === 'bahan' ? 'Bahan' : type === 'upah' ? 'Upah' : type === 'alat_mesin' ? 'Alat & Mesin' : type === 'subkon' ? 'Subkon' : type === 'overhead' ? 'Overhead' : '' 
